import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { invalidateTimeEntries } from './keys';
import { ITimeEntry } from './types';

interface ISubmitTimeEntryVariables {
	day: string;
	hours?: number;
	attested: boolean;
	note?: string;
}

export const useSubmitTimeEntryMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: unknown) => void;
	onSuccess?: (data: ITimeEntry) => void;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ day, hours, attested, note }: ISubmitTimeEntryVariables) =>
			userSession.webServiceHelper.callAsync<ITimeEntry>(`TimeEntry/days/${encodeURIComponent(day)}/submit`, 'POST', {
				attested,
				hours,
				note,
			}),
		onError,
		onSuccess,
		onSettled: () => invalidateTimeEntries(),
	});
};
